import HttpClient from "../http/http_client";
export const getTeamRequest = async() => {
    try {
        const response = await HttpClient.get('teams/');

        return {
            success : true,
            data : response.data,
        }
    } catch (error) {
        if (error.response) {
            const {status, data} = error.response;
            return {
                success : false,
                status : status,
                errors : data?.errors || null,
            }
        }
    }
};

export const getTeamByIdRequest = async(id) => {
    try {
        const response = await HttpClient.get(`team/${id}`);
        return {
            success : true,
            data : response.data,
        }
    } catch (error) {
        if (error.response) {
            const {status, data} = error.response;
            return {
                success : false,
                status : status,
                errors : data?.errors || null,
            }
        }

        return {
            success : false,
            status : null,
            errors : "Something went wrong. Please try again."
        };
    }
}